import authLogic from "./auth/authLogic";
import homeLogic from "./home/homeLogic";
import feedLogic from "./feed/feedLogic";

export default [
  ...authLogic,
  ...homeLogic,
  ...feedLogic,
];
